import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export enum PermissionGroupEnum {
  COMPANY = 'COMPANY',
  VENDOR = 'VENDOR',
  ADMIN = 'ADMIN',
  ACCOUNTING = 'ACCOUNTING',
  READONLY = 'READONLY',
  SUPPORT = 'SUPPORT',
  FLEET_MANAGER = 'FLEET_MANAGER',
  RETURNS = 'RETURNS',
  DAMAGES = 'DAMAGES',
  OPERATION = 'operation',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  DEPO = 'DEPO',
  SUPER_ADMIN = 'SUPER_ADMIN',
  XDOCK = 'XDOCK'
}

export class IDocument {
  id: string;
  name: string;
  url: string;
  type: string;
  description: string;
  creatorId: number;
  createdAt: string;
  permission: PermissionGroupEnum;
  categories: string[];
  units: string[];
  showPage?: string[];
}

export class IDocumentResponse {
  @Type(() => IDocument)
  result: IDocument;
}

export class IDocumentListResponse extends IPagination {
  @Type(() => IDocument)
  results: IDocument[];
}

export class IDocumentQueryDto extends IQueryPaginationDto {
  permission?: PermissionGroupEnum;
  name?: string;
  categories?: string;
  units?: string[];
  showPage?: string[];
}

export class IDocumentPostDto {
  name: string;
  url: string;
  type: string;
  description?: string;
  categories: string[];
  permission: PermissionGroupEnum;
  units: string[];
  regionId?: string[];
  permissionGroup?: string;
  showPage?: string[];
}

export class IDocumentPatchDto {
  name?: string;
  url?: string;
  type?: string;
  description?: string;
  category?: string;
  permission?: PermissionGroupEnum;
  regionId?: string[];
  permissionGroup?: string;
  showPage?: string[];
}

// Document File Upload Types
export class DocumentFileResponseDto {
  id: number;
  documentId: string;
  url: string;
  fileUrl: string;
  date: string;
  fileId: string;
  status: number;
  userId: number;
  fileName: string | null;
  mimeType: string | null;
}

export class IDocumentFilesListResponse {
  @Type(() => DocumentFileResponseDto)
  results: DocumentFileResponseDto[];
}

export class IDocumentFileUploadResponse {
  result: {
    id: number;
  };
  uploadUrl: string;
}

export class IDocumentFileDownloadUrlResponse {
  downloadUrl: string;
}

export class IDocumentFileStatusResponse {
  result: {
    status: 'pending' | 'completed' | 'failed';
    fileId?: string;
  };
}

export class IDocumentLog {
  id: string;
  documentId: string;
  userId: number;
  username: string;
  actionType: string;
  diff: object;
  previousState: object;
  currentState: object;
  message: string;
  date: string;
  createdAt: string;
}

export class IDocumentLogsResponse extends IPagination {
  @Type(() => IDocumentLog)
  results: IDocumentLog[];
}

export class IDocumentLogQueryDto extends IQueryPaginationDto {
  documentId?: string;
}
